(() => {
  if (customElements.get('product-form')) {
    return;
  }

  class ProductForm extends HTMLElement {
    constructor() {
      super();
      this.form = this.querySelector('form');
      this.submitButton = this.form.querySelector('[name="add"]');
      this.cartDrawer = document.querySelector('cart-drawer');
      this.productBar = document.querySelector(
        `#ProductBar-${this.dataset.sectionId}`
      );
      this.isSubmitting = false;

      this.form.addEventListener(
        'submit',
        this.onSubmitHandler.bind(this)
      );
    }

    // Every control that can start an add-to-cart for this form. The sticky
    // bar proxies its click to this.submitButton, which is display:none, so
    // adding a CSS class to it never stopped a second tap.
    addButtons() {
      return [
        this.submitButton,
        this.productBar?.querySelector('[name="add"]')
      ].filter(Boolean);
    }

    lockAddButtons(lock) {
      this.addButtons().forEach(button => {
        if (lock) {
          button.setAttribute('disabled', 'disabled');
          button.setAttribute('aria-busy', 'true');
          button.classList.add('disabled');
        } else {
          button.removeAttribute('disabled');
          button.removeAttribute('aria-busy');
          button.classList.remove('disabled');
        }
      });
    }

    onSubmitHandler(event) {
      event.preventDefault();

      // Re-entrancy guard. Without it a double-tap fires two /cart/add
      // requests. Addon properties make each line unique, so they do not
      // merge into quantity 2 - the customer gets two separate line items,
      // and the cart gives them no way to delete either one.
      if (this.isSubmitting) {
        return;
      }

      const purchaseOptions = document.querySelector(
        'purchase-options'
      );
      if (
        !!purchaseOptions &&
        !purchaseOptions.isOneTimePurchase() &&
        !this.hasAttribute('data-has-selling-plan')
      ) {
        purchaseOptions.showError();
        return;
      }

      this.isSubmitting = true;
      this.lockAddButtons(true);

      const config = fetchConfig('javascript');
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      delete config.headers['Content-Type'];
      const formData = new FormData(this.form);
      formData.append(
        'sections',
        this.cartDrawer
          .getSectionsToRender()
          .map(section => section.section)
      );
      formData.append('sections_url', window.location.pathname);
      config.body = formData;

      fetch(`${routes.cart_add_url}`, config)
        .then(response => response.json())
        .then(response => {
          if (response.status) {
            this.handleErrorMessage(response.description);
            return;
          }

          this.cartDrawer.renderContents(response);
        })
        .catch(error => {
          console.error(error);
        })
        .finally(() => {
          this.isSubmitting = false;
          this.lockAddButtons(false);
        });
    }

    handleErrorMessage(errorMessage = false) {
      const errorWrapper = this.querySelector('[data-error-wrapper]');
      if (!errorWrapper) return;

      let message = errorMessage;

      if (typeof errorMessage === 'object' && errorMessage !== null) {
        message = Object.values(errorMessage).flat().join(', ');
      }

      errorWrapper.classList.toggle('hidden', !message);
      errorWrapper.textContent = message || '';
    }


    toggleAddButton(disable, text) {
      [
        this.submitButton,
        this.productBar?.querySelector('[name="add"]')
      ].forEach(submitButton => {
        if (disable) {
          submitButton?.setAttribute('disabled', 'disabled');
          if (text && submitButton) submitButton.textContent = text;
        } else if (submitButton) {
          submitButton.removeAttribute('disabled');
          submitButton.textContent = this.hasAttribute(
            'data-has-selling-plan'
          )
            ? window.variantStrings.addSubscriptionToCart
            : window.variantStrings.addToCart;
        }
      });
    }
  }

  customElements.define('product-form', ProductForm);
})();